import { lazy, Suspense } from "react";
import { Layout } from "@/shared/components/layout/Layout";

const Dashboard = lazy(() => import("./Dashboard"));

const Index = () => {
  return (
    <Layout>
      <Suspense fallback={null}>
        <Dashboard />
      </Suspense>
    </Layout>
  );
};

export default Index;
